import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";
import red from "components/shared/tokens/color/red";

const DARK_NAVY = "#293142";
const MUTED = "#9299aa";
const BORDER = "#dfe4ed";
const PAGE_BACKGROUND = "#f5f6fb";

export const Page = styled.main`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  overflow: hidden;
  background: ${PAGE_BACKGROUND};
  color: ${DARK_NAVY};
  font-family: ${fontFamilies.regular};
`;

export const PageShell = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  background: ${PAGE_BACKGROUND};
`;

export const Header = styled.header`
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: #ffffff;

  @media (max-width: 420px) {
    padding-right: 16px;
    padding-left: 16px;
  }
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  color: ${DARK_NAVY};
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z400};
  line-height: 1.3;
`;

export const ActionButton = styled.button`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  &:active {
    opacity: 0.7;
  }
`;

export const Content = styled.section`
  min-height: 0;
  overflow-y: auto;
  padding: 28px 24px 36px;

  @media (max-width: 420px) {
    padding: 24px 16px 28px;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 18px;
  color: ${DARK_NAVY};
  font-family: ${fontFamilies.semiBold};
  font-size: ${fontSizes.z500};
  line-height: 1.25;
`;

export const AddUserForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FormCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border: 1px solid #f0f2f6;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 4px 18px rgba(41, 49, 66, 0.06);

  @media (max-width: 420px) {
    border-radius: 20px;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  min-height: 49px;
  padding: 12px 14px;
  border: 1px solid ${BORDER};
  border-radius: 11px;
  outline: 0;
  background: ${({ $readOnly }) => ($readOnly ? "#f5f6f9" : "#ffffff")};
  color: ${DARK_NAVY};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z300};
  cursor: ${({ $readOnly }) => ($readOnly ? "default" : "text")};

  &::placeholder {
    color: #a3aaba;
  }

  &:focus {
    border-color: ${({ $readOnly }) => ($readOnly ? BORDER : red.z400)};
    box-shadow: ${({ $readOnly }) =>
      $readOnly ? "none" : `0 0 0 2px ${red.z100}`};
  }

  &[aria-invalid="true"] {
    border-color: ${red.z500};
  }
`;

export const FieldMessage = styled.p`
  margin: 5px 2px 0;
  color: ${red.z600};
  font-size: ${fontSizes.z100};
  line-height: 1.4;
`;

export const LookupMessage = styled.p`
  margin: 0;
  padding: 11px 13px;
  border-radius: 9px;
  background: ${({ $isError, $isWarning }) =>
    $isError ? red.z100 : $isWarning ? "#fff2dc" : "#eaf6ee"};
  color: ${({ $isError, $isWarning }) =>
    $isError ? red.z700 : $isWarning ? "#99430f" : "#267347"};
  font-size: ${fontSizes.z200};
  line-height: 1.45;
`;

export const SubmitArea = styled.footer`
  padding: 14px 24px;
  padding-bottom: max(14px, env(safe-area-inset-bottom));
  border-top: 1px solid #e7eaf0;
  background: #ffffff;
  box-shadow: 0 -7px 22px rgba(41, 49, 66, 0.04);

  @media (max-width: 420px) {
    padding-right: 16px;
    padding-left: 16px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  min-height: 50px;
  padding: 12px 16px;
  border: 0;
  border-radius: 12px;
  background: ${({ disabled }) => (disabled ? "#d1d5dd" : red.z500)};
  color: #ffffff;
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z400};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:active:not(:disabled) {
    background: ${red.z600};
  }
`;
